<div class="header">
  <h4 class="header4-text">Videos</h4>
  <a class="body-text" (click)="onViewAllClick()">View All</a>
</div>
<div class="video-container">
    <app-video-card *ngFor="let video of videos" [video]="video" (click)="onVideoClick(video)"></app-video-card>
</div>